import { useEffect, useState } from "react";
import styled from "styled-components";
import IconArrow from "../../assets/images/icon-arrow-3.svg";
import IconEdit from "../../assets/images/icon-edit.svg";
import IconDelete from "../../assets/images/icon-delete.svg";
import IconDashboard from "../../assets/images/icon-dashboard.svg"
import { MenuItem, Select } from "@mui/material";
import { formatDateByString } from "../../utils/default";
import IconPlace from "../../assets/images/icon-location.svg";
import IconEvent from "../../assets/images/icon-calendar-1.svg";
import IconService from "../../assets/images/icon-report-1.svg";
import ButtonComponent from "../button";
import IconQRCode from "../../assets/images/icon-qrcode.svg";

const Container = styled.div`
    width: 100%;
    overflow-y: auto;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    .header-table-box {
        height: 52px;
        background-color: #F2F5FE;

        .header-div {
            cursor: pointer;
        }

        th {
            color: #25368D;
            font-size: 15px;
            font-weight: 500;
            line-height: 22.43px;
            text-align: left;
            padding: 0px 16px;
        }

        .width-100 {
            width: 100%;
        }

        .width-60 {
            width: 60%;
        }

        .width-20 {
            width: 20%;
        }

        .width-280px {
            width: calc(280px - 32px);
            max-width: calc(280px - 32px);
            min-width: calc(280px - 32px);
        }

        .width-240px {
            width: calc(240px - 32px);
            max-width: calc(240px - 32px);
            min-width: calc(240px - 32px);
        }

        .width-180px {
            width: calc(180px - 32px);
            max-width: calc(180px - 32px);
            min-width: calc(180px - 32px);
        }

        .width-160px {
            width: calc(160px - 32px);
            max-width: calc(160px - 32px);
            min-width: calc(160px - 32px);
        }

        .width-70px {
            width: calc(70px - 32px);
            max-width: calc(70px - 32px);
            min-width: calc(70px - 32px);
        }

        .image-arrow {
            margin-left: 8px;
            transition: all 0.3s ease;

            &.open {
                transform: rotateX(180deg);
            }
        }

    }

    .row-table-box {

        td {
            padding: 24px 16px;
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: #F2F2F2;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
        }

        .icon-edit {
            cursor: pointer;
            width: 16px;
        }

        .icon-delete {
            cursor: pointer;
            width: 28px;
        }

        .icon-type-box {
            width: 28px;
            min-width: 28px;
            height: 28px;
            border-radius: 50%;
            background-color: #E3E9FD;
        }

        .dropdown {
            width: 100%;
            height: 30px;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
            border-radius: 24px;

            &.ACTIVE {
                background-color: #DFF7F1;
            }

            &.INACTIVE {
                background-color: #F7F7FD;
            }
        }

        .status-line {
            width: 100%;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;

            .status-box {
                width: 14px;
                height: 14px;
                border-radius: 4px;
                margin-top: 1px;
                margin-right: 8px;

                &.ACTIVE {
                    background-color: #69D85F;
                }

                &.INACTIVE {
                    background-color: #D6DFE8;
                }
            }
        }

        .action-box {
            gap: 4px;
        }
    }
`;

function TableEFComponent({
    listData,
    order,
    onUpdate,
    onDelete,
    onChangeStatus,
    onOrder,
    onOpenQRCode,
    onViewDashboard,
}) {
    const [orderOption, setOrderOption] = useState({
        order: "DESC",
        orderBy: "evaluation_name",
    })
    const [rows, setRows] = useState([
        {
            id: "",
            evaluation_name: "",
            evaluation_type: "",
            department_displayname: "",
            division_displayname: "",
            location_displayname: "",
            province_displayname: "",
            created_at: "",
            status: "",
            evaluation_form_detail: null,
        },
    ])

    useEffect(() => {
        if (Array.isArray(listData)) {
            let list = JSON.parse(JSON.stringify(listData));
            list = list.map(x => {
                let detail = {
                    id: x.evaluation_form_evaluation_form_id,
                    evaluation_name: x.evaluation_form_evaluation_name,
                    evaluation_type: x.evaluation_form_evaluation_type,
                    department_displayname: x.department_department_name,
                    division_displayname: x.division_division_name,
                    location_displayname: x.evaluation_form_evaluation_type === "Place" ? x.location_location_name : "",
                    province_displayname: x.evaluation_form_evaluation_type === "Place" ? x.location_province : "",
                    created_at: x.evaluation_form_created_at ? formatDateByString(x.evaluation_form_created_at, "DD MMMM YYYY HH:mm:ss") : "",
                    status: x.evaluation_form_status,
                    evaluation_form_detail: x,
                }
                return detail
            })
            setRows(list)
        } else {
            setRows([])
        }
    }, [listData])
    useEffect(() => {
        if (order) {
            setOrderOption(order)
        }
    }, [order])

    function handleSort(key) {
        let detail = { ...orderOption };
        if (detail.orderBy === key) {
            detail.order = detail.order === "ASC" ? "DESC" : "ASC";
        } else {
            detail.orderBy = key;
            detail.order = "DESC";
        }
        setOrderOption(detail);
        onOrder && onOrder(detail);
    }
    function handleChangeStatus(param) {
        onChangeStatus && onChangeStatus(param)
    }
    function handleUpdate(param) {
        onUpdate && onUpdate(param)
    }
    function handleDelete(param) {
        onDelete && onDelete(param)
    }
    function handleOpenQRCode(param) {
        onOpenQRCode && onOpenQRCode(param)
    }
    function handleViewDashboard(param) {
        onViewDashboard && onViewDashboard(param)
    }

    return (
        <Container>
            <Table>
                <thead>
                    <tr className="header-table-box">
                        <ThBox
                            className={"width-100"}
                            label={"EF Name"}
                            orderKey={"evaluation_name"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-280px"}
                            label={"ประเภทแบบสอบถาม"}
                            orderKey={"evaluation_type"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-180px"}
                            label={"วันที่สร้างแบบสอบถาม"}
                            orderKey={"created_at"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-160px"}
                            label={"สถานะ"}
                            orderKey={"status"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-160px"}
                            label={"คิวอาร์โค้ด"}
                            orderKey={"qrcode"}
                        />
                        <th className="width-70px"></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((value, index) => {
                        return (
                            <TrBox
                                key={index}
                                dataItem={value}
                                onUpdate={handleUpdate}
                                onDelete={handleDelete}
                                onChangeStatus={handleChangeStatus}
                                onOpenQRCode={handleOpenQRCode}
                                onViewDashboard={handleViewDashboard}
                            />
                        )
                    })}
                    {rows.length === 0 &&
                        <TrNodataBox />
                    }
                </tbody>
            </Table>
        </Container>
    )
}

function ThBox({
    label,
    orderKey,
    order,
    orderBy,
    onSort,
    className,
}) {
    function handleSort() {
        onSort && onSort(orderKey)
    }
    return (
        <th className={`${className}`}>
            <div className="header-div vertical-center" onClick={handleSort}>
                {label}
                {orderBy === orderKey &&
                    <img
                        className={`image-arrow ${order === "DESC" ? "" : "open"}`}
                        alt="img"
                        src={IconArrow}
                    />
                }
            </div>
        </th>
    )
}

function TrBox({
    dataItem,
    onUpdate,
    onDelete,
    onChangeStatus,
    onOpenQRCode,
    onViewDashboard,
}) {
    const [status, setStatus] = useState("INACTIVE");

    useEffect(() => {
        if (dataItem?.status) {
            setStatus(dataItem?.status)
        }
    }, [dataItem])

    function handleChangeStatus(event) {
        const value = event.target.value;
        setStatus(value);
        const detail = { ...dataItem }
        if (detail) {
            detail.status = value
        }
        onChangeStatus && onChangeStatus(detail)
    }
    function handleUpdate() {
        onUpdate && onUpdate(dataItem)
    }
    function handleDelete() {
        onDelete && onDelete(dataItem)
    }
    function handleOpenQRCode() {
        onOpenQRCode && onOpenQRCode(dataItem)
    }
    function handleViewDashboard() {
        onViewDashboard && onViewDashboard(dataItem)
    }

    return (
        <tr className="row-table-box">
            <td>{dataItem?.evaluation_name || '-'}</td>
            <td>
                <div>
                    <div className="vertical-center" style={{ gap: "8px" }}>
                        <div className="content-center icon-type-box">
                            <img alt="img" src={dataItem?.evaluation_type === "Place" ? IconPlace : dataItem?.evaluation_type === "Event" ? IconEvent : IconService}
                                style={{ width: "16px" }} />
                        </div>
                        {dataItem?.evaluation_type || '-'}
                    </div>
                    {dataItem?.evaluation_type === "Place" &&
                        <>
                            <div style={{ marginTop: "8px" }}>
                                {dataItem?.location_displayname || ''}
                            </div>
                            <div style={{ marginTop: "8px" }}>
                                {dataItem?.province_displayname ? `(${dataItem?.province_displayname})` : ''}
                            </div>
                        </>
                    }
                </div>
            </td>
            <td>{dataItem?.created_at || '-'}</td>
            <td>
                <Select
                    className={`dropdown ${status}`}
                    value={status}
                    onChange={handleChangeStatus}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value={"ACTIVE"}>Active</MenuItem>
                    <MenuItem value={"INACTIVE"}>In-Active</MenuItem>
                </Select>
            </td>
            <td>
                <ButtonComponent
                    label={"ดูคิวอาร์โค้ด"}
                    icon={IconQRCode}
                    variant={"primary"}
                    sceenSize={"lg"}
                    style={{
                        width: "140px",
                        maxWidth: "140px",
                        minWidth: "140px",
                        height: "30px",
                        fontSize: "15px",
                        fontWeight: "500",
                    }}
                    onClick={handleOpenQRCode}
                />
            </td>
            <td>
                <div className="action-box content-center">
                    <img className="icon-edit" alt="img" src={IconEdit} onClick={handleUpdate} />
                    <img className="icon-delete" alt="img" src={IconDelete} onClick={handleDelete} />
                    <img className="icon-edit" alt="img" src={IconDashboard} onClick={handleViewDashboard} />
                </div>
            </td>
        </tr>
    )
}

function TrNodataBox() {
    return (
        <tr className="row-table-box">
            <td colSpan="7" style={{ textAlign: "center" }}>ไม่มีข้อมูล</td>
        </tr>
    )
}

export default TableEFComponent;